export const blockIconsSocialMoodNew = (
	<span className='material-symbols-outlined'>mood</span>
);
